import { render, staticRenderFns } from "./PosActionMenu.vue?vue&type=template&id=30fc7c2b&scoped=true"
import script from "./PosActionMenu.vue?vue&type=script&lang=js"
export * from "./PosActionMenu.vue?vue&type=script&lang=js"
import style0 from "./PosActionMenu.vue?vue&type=style&index=0&id=30fc7c2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc7c2b",
  null
  
)

export default component.exports